import { Anchor, Text } from '@zillow/constellation-10';
import type { ComponentType } from 'react';

import type { TextPropsInterface } from '@zillow/constellation-10';
import type { PartialMessageProps } from '../../model/PartialMessage';

type Props = {
  partialMessages: Array<PartialMessageProps>;
  // TODO: accept on TextPropsInterface once BE is updated to use v10 fontType
  fontType?: 'body' | 'bodySmall' | 'finePrint' | (string & {});
  linkComponent?: ComponentType<React.ComponentProps<typeof Anchor>>;
  onUrlClick?: (e: React.MouseEvent<HTMLAnchorElement>, url: string, text: string) => void;
  eventId?: string;
};

const fontTypeMap: Record<string, string> = {
  body: 'body',
  bodySmall: 'body-sm',
  finePrint: 'body-xs',
};

export const PartialMessage = ({
  partialMessages = [],
  fontType = 'body',
  linkComponent: LinkComponent = Anchor,
  onUrlClick,
  eventId,
}: Props) => {
  return (
    <div data-testid="PartialMessage">
      {partialMessages.map(({ url, text, isBold }, i) => (
        <Text
          key={`partial-message-${text}`}
          textStyle={
            (isBold
              ? `${fontTypeMap[fontType] ?? fontType}-bold`
              : (fontTypeMap[fontType] ?? fontType)) as TextPropsInterface['textStyle']
          }
          css={{ color: 'currentColor' }}
        >
          {url ? (
            <LinkComponent
              key={i}
              href={url}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => onUrlClick?.(e, url, text)}
              target="_blank"
              data-eventid={eventId}
            >
              {`${text}`}
            </LinkComponent>
          ) : (
            `${text}`
          )}
        </Text>
      ))}
    </div>
  );
};
